import * as React from 'react';

export const CustomDataTab = () => {
  return <div>TBA tab content: CustomDataTab</div>;
};
